import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const TaxaImpostoPageController = () => {
  //estados globais
  const taxaImpostoState = useAppSelector((state) => state.taxaImposto);

  const Page = pages[taxaImpostoState.page];

  return <Page key={taxaImpostoState.page} />;
};

export default TaxaImpostoPageController;
